import React from 'react';

import { Tooltip, ColorPickerInput } from '@wix/wix-base-ui';
import { symbol as Symbol } from '@wix/santa-editor-symbols';

const PLACEHOLDER_COLOR_VALUE = '#898989';

export interface ConnectedColorPlaceholderProps {
  colorValue?: string;
}

export const ConnectedColorIcon = () => <Symbol name="pageData" />;

export const ConnectedColorPlaceholder: React.FC<
  ConnectedColorPlaceholderProps
> = ({ colorValue = PLACEHOLDER_COLOR_VALUE }) => (
  <Tooltip
    content="WixData_Connected_Color_Tooltip"
    shouldTranslate={true}
    isHint
  >
    <ColorPickerInput value={colorValue} symbol={ConnectedColorIcon} />
  </Tooltip>
);

export default ConnectedColorPlaceholder;
